import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { mapModelDtoToModelEntity } from '../../../shared/utils/mapping/mapping.util';
import { axiosInstance } from '../../shared/api/axios-instance';
import { LocalStorageProperties } from '../../shared/enums/local-storage-properties.enum';
import localStorageService from '../../shared/services/local-storage/local-storage.service';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { ModelDto } from '../dtos/model.dto';
import { ModelEntity } from '../models/model-entity.model';

export const getModelsByBrand = createAsyncThunk<
  ModelEntity[],
  number,
  Record<string, unknown>
>('firmware/getModelsByBrand', async brandId => {
  const mandantId = localStorageService.get(
    LocalStorageProperties.SELECTED_MANDANT
  ) as string | null;

  const url = createPathParams<'mandantId' | 'brandId'>(
    Endpoints.GET_MODELS_BY_BRAND,
    {
      ...(mandantId !== null && { mandantId: parseInt(mandantId, 10) }),
      brandId,
    }
  );
  const { data }: AxiosResponse<ModelDto[]> = await axiosInstance.get(url);
  return data && data.length ? data.map(mapModelDtoToModelEntity) : [];
});
